import React from "react";
import { styled } from "@mui/material/styles";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";

const StyledColorToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  display: "flex",
  gap: "5px",
  [theme.breakpoints.down("tablet")]: {
    gap: "8px",
    flexWrap: "wrap",
  },
}));

export const StyledColorToggleButton = styled(ToggleButton)(({ theme, swatch, sx }) => ({
  height: "24px",
  width: "24px",
  border: "2px solid #ffffff !important",
  borderRadius: "50% !important",
  background: swatch ? `url(${swatch})` : "#000000",
  "&:hover": {
    backgroundColor: theme.palette.background.inverted,
    color: theme.palette.text.inverted,
  },
  "&.Mui-selected": {
    backgroundColor: `${theme.palette.background.inverted} !important`,
    outline: `2px solid ${theme.palette.background.inverted}`,
    color: theme.palette.text.inverted,
  },
  [theme.breakpoints.down("laptop")]: {
    height: "36px",
    width: "36px",
  },
  ...sx,
}));

const ColorSwitcher = ({ data }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleChangeColorVariant = (value) => {
    data.audios.CHANGE_COLOR.play();
    const variant = data.product.variants.find(
      (e) => e.color === value && e.size === data.variant.size
    );
    if (variant) {
      const productID = data.product.id.replace("gid://shopify/Product/", "");
      const variantID = variant.id.replace("gid://shopify/ProductVariant/", "");
      const queryParams = location.search;
      const newPath = `/${productID}/${variantID}${queryParams}`;

      navigate(newPath);
    }
  };

  return (
    <StyledColorToggleButtonGroup
      exclusive
      value={data.variant.color}
      onChange={(_, value) => handleChangeColorVariant(value)}
    >
      {data.product.options.color.map((color, index) => (
        <StyledColorToggleButton
          key={index}
          value={color}
          swatch={data.swatches?.find((swatch) =>
            swatch.includes(color.replaceAll(" ", "-").toLowerCase())
          )}
        />
      ))}
    </StyledColorToggleButtonGroup>
  );
};

export default React.memo(ColorSwitcher);
